import { ListViewLocal } from '@app/core/list-view/ListViewLocal';
import { fleetListDevicesBalenaDevices } from '@mi-front/api-v2';
import { BalenaDevicesGrid } from './balena-devices-grid/BalenaDevicesGrid';
import { BALENA_DEVICES_FILTERS_CONFIG } from './filters/balena-devices-filters-config';

/**
 * Balena devices list: loads the full fleet once, filters locally, no pagination.
 */
export function BalenaDevicesList() {
  return (
    <ListViewLocal
      listId="fleet-balena-devices"
      filters={BALENA_DEVICES_FILTERS_CONFIG}
      queryFn={() => fleetListDevicesBalenaDevices()}
      ListComponent={BalenaDevicesGrid}
      enablePagination={false}
      showProgress
    />
  );
}
